import React from 'react';

import AdministrationView from 'views/Administration';

export default ( { match, history } ) => (
  <AdministrationView
    pathLayout={match.url}
    currentPath={history.location.pathname}
  />
);
